import { BrowserRouter, Route, Routes } from "react-router-dom";
import SiteLayout from "./layouts/SiteLayout";
import HomePage from "./pages/HomePage";
import PricingPage from "./pages/PricingPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import DocsPage from "./pages/DocsPage";
import ApiReferencePage from "./pages/ApiReferencePage";
import BlogPage from "./pages/BlogPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import ComingSoonPage from "./pages/ComingSoonPage";
import NotFoundPage from "./pages/NotFoundPage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<SiteLayout />}>
          <Route index element={<HomePage />} />

          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />

          <Route path="/docs" element={<DocsPage />} />
          <Route path="/api-reference" element={<ApiReferencePage />} />
          <Route path="/blog" element={<BlogPage />} />

          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />

          {/* Advertised in the footer of the old site, but never built - those
              links 404'd there too. Give them real URLs instead of a 404. */}
          <Route path="/changelog" element={<ComingSoonPage title="Changelog" />} />
          <Route path="/integrations" element={<ComingSoonPage title="Integrations" />} />
          <Route path="/careers" element={<ComingSoonPage title="Careers" />} />
          <Route path="/community" element={<ComingSoonPage title="Community" />} />

          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
